import Box from "@material-ui/core/Box";
import CircularProgress from "@material-ui/core/CircularProgress";
import React, { FC, useEffect, useRef, useState } from "react";
import { Theme } from "@material-ui/core/styles";
import { styled } from "@material-ui/styles";
import { useDispatch, useSelector } from "react-redux";

import StateProvinceSelectionDasboard from "../../CampaignCreationCustomSlides/StateProvinceSelectionSlide/components/StateProvinceSelectionDasboard";
import { PageStepComponentProps } from "../../../components/modules/BaseStepper/BaseStepper";
import { ReduxApplicationState } from "../../../types/ReduxTypes/ReduxApplicationState";
import { getGeoTargetOptions, setSelectedGeoTargetOptions } from "../../../redux/reducers/campaignToCreate";

const Root = styled("div")({
  width: "100%",
});

const LoadingWrapper = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "32px 0",
});

const EmptyText = styled("div")(({ theme }: { theme: Theme }) => ({
  fontSize: 13,
  color: theme.palette.brand.gray500,
  padding: "16px 0",
}));

type SetStateAction<S> = S | ((prevState: S) => S);

const StateProvinceView: FC<Partial<PageStepComponentProps>> = () => {
  const dispatch = useDispatch();

  const geoTargetOptions = useSelector((s: ReduxApplicationState) => s.campaignToCreate.geoTargetOptions);
  const selectedGeoTargetOptions = useSelector(
    (s: ReduxApplicationState) => s.campaignToCreate.selectedGeoTargetOptions,
  );

  const hasFetched = useRef(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!hasFetched.current && !geoTargetOptions) {
      hasFetched.current = true;
      setIsLoading(true);
      dispatch(getGeoTargetOptions());
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (isLoading && geoTargetOptions) setIsLoading(false);
  }, [geoTargetOptions, isLoading]);

  const handleSetSelected = (value: SetStateAction<string[]>) => {
    const next = typeof value === "function" ? value(selectedGeoTargetOptions) : value;
    dispatch(setSelectedGeoTargetOptions(next));
  };

  if (isLoading) {
    return (
      <LoadingWrapper>
        <CircularProgress size={28} />
      </LoadingWrapper>
    );
  }

  if (!geoTargetOptions) {
    return <EmptyText>No region data available.</EmptyText>;
  }

  return (
    <Root>
      <StateProvinceSelectionDasboard
        geoTargetOptions={geoTargetOptions}
        selectedGeoTargetOptions={selectedGeoTargetOptions}
        setSelectedGeoTargetOptions={handleSetSelected}
      />
    </Root>
  );
};

export default StateProvinceView;
